import { MontaProduct } from '@domain/connection/models/MontaProduct';
import { ApiClient } from '../../ApiClient';
import { ConnectionDTO } from '../dto/MarketplaceDTOs';
import { FullSyncJob } from '@domain/connection/models/ImportJob';

export class MontaConnectorDataSource {

  constructor(private api: ApiClient) {
  }

  async addMontaMarketplaceConnection(code: string, redirectUri: string): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>('/connections/monta', {
      code,
      redirectUri
    });
    return response.data;
  }

  async reconnect(connectionId: string, username: string, password: string): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>(`/connections/monta/${connectionId}/reconnect`, {
      username,
      password
    });
    return response.data;
  }

  async fetchProducts(connectionId: string): Promise<MontaProduct[]> {
    const response = await this.api.get<{ Products: MontaProduct[] }>(`/connections/monta/products?connectionId=${connectionId}`);
    return response.data.Products;
  }

  async syncFull(connectionId: string): Promise<FullSyncJob[]> {
    const response = await this.api.post<{ jobs: FullSyncJob[] }>(`/connections/monta/sync/full`, null, { params: { connectionId } });
    return response.data.jobs;
  }
}
